{
  "en": {
    "ai": {
      "settings": {
        "title": "AI settings",
        "description": "Configuration for AI features in your workspace.",
        "budget": {
          "title": "Monthly budget",
          "description": "Monthly cost cap for AI usage (test phase). Recalculated based on token usage across all conversations this month.",
          "budget_label": "Budget",
          "usage_label": "Used this month",
          "save": "Save"
        }
      },
      "assistant": {
        "name": "Ziggy",
        "all_projects": "All projects",
        "empty_state": {
          "title": "How can I help you?",
          "subtitle": "Ask me anything about your clients"
        },
        "suggestions": {
          "open_decisions": "Which decisions are still open?",
          "unassigned_units": "Which units have no customer yet?",
          "help_notifications": "How do I set up notifications?",
          "help_project_settings": "Where do I find project settings?"
        },
        "input": {
          "placeholder": "Ask about your clients...",
          "hint": "Enter to send · Shift+Enter for new line",
          "disclaimer": "Results may be inaccurate. Always verify important information."
        },
        "errors": {
          "generic": "Something went wrong. Please try again.",
          "budget_reached": "The monthly AI budget for this workspace has been reached. Contact an administrator to raise the limit."
        },
        "cap": {
          "message": "You've reached the conversation limit.",
          "action": "Start a new conversation"
        },
        "history": {
          "title": "Past conversations",
          "empty": "No past conversations yet"
        },
        "support_cta": {
          "prompt": "Not the answer you were looking for?",
          "action": "Contact support"
        }
      }
    }
  }
}
